import React, { useState } from "react";
import { StaticImage } from "gatsby-plugin-image";
import PropTypes from "prop-types";
import { useInView } from "react-intersection-observer";

// components
import TeamMemberCard from "../TeamMemberCard";
import BioModal from "../BioModal";

// data
import { memberDetails } from "../MemberDetails";

// styles
import * as styles from "./MedicalAdvisoryBoardNew.module.css";

const teamDetails = [
  {
    id: "francine-r-kaufman-md",
    drName: "Francine R. Kaufman, MD",
    designation: "Chief Medical Advisor",
    company: "Senseonics",
    drImage: (
      <StaticImage
        src="../../../images/aboutUs/francine_v2.png"
        alt="Francine R. Kaufman"
        placeholder="blurred"
        quality={100}
      />
    ),
  },
  {
    id: "osama-hamdy-md",
    drName: "Osama Hamdy, MD, PhD",
    designation: "Director Inpatient Diabetes Program",
    company: "Joslin Diabetes Center",
    drImage: (
      <StaticImage
        src="../../../images/aboutUs/osama_v2.png"
        alt="Osama Hamdy"
        placeholder="blurred"
        quality={100}
      />
    ),
  },
  {
    id: "ambrish-mithal-md",
    drName: "Ambrish Mithal, MD",
    designation: "Chairman and Head of Endocrinology & Diabetes",
    company: "Max Healthcare",
    drImage: (
      <StaticImage
        src="../../../images/aboutUs/ambrish_v2.png"
        alt="Ambrish Mithal"
        placeholder="blurred"
        quality={100}
      />
    ),
  },
  {
    id: "elbert-huang-md",
    drName: "Elbert Huang, MD",
    designation: "Director of the Center",
    company: "Chronic Disease Research",
    drImage: (
      <StaticImage
        src="../../../images/aboutUs/elbert_v2.png"
        alt="Elbert Huang"
        placeholder="blurred"
        quality={100}
      />
    ),
  },
  {
    id: "rohit-satoskar-md",
    drName: "Rohit Satoskar, MD",
    designation: "Director of Medical Services",
    company: "MedStar Georgetown Transplant Institute",
    drImage: (
      <StaticImage
        src="../../../images/aboutUs/rohit_v2.png"
        alt="Rohit Satoskar"
        placeholder="blurred"
        quality={100}
      />
    ),
  },
  {
    id: "jeffrey-mechanick-md",
    drName: "Jeffrey Mechanick, MD",
    designation: "Director of Metabolic Support",
    company: "Icahn School of Medicine at Mount Sinai",
    drImage: (
      <StaticImage
        src="../../../images/aboutUs/jeffrey_v2.png"
        alt="Jeffrey Mechanick"
        placeholder="blurred"
        quality={100}
      />
    ),
  },
  {
    id: "ashutosh-shukla",
    drName: "Dr. Ashutosh Shukla",
    designation: "Co-Founder & Medical Director",
    company: "Prana Integrative Medicine Institute",
    drImage: (
      <StaticImage
        src="../../../images/aboutUs/ashutosh_shukla.png"
        alt="Ashutosh Shukla"
        placeholder="blurred"
        quality={100}
      />
    ),
  },
  {
    id: "shashank-joshi-medical-board",
    drName: "Shashank R Joshi",
    designation: "Consultant Endocrine and Metabolic Physician",
    company: "",
    drImage: (
      <StaticImage
        src="../../../images/aboutUs/shashank_v2.png"
        alt="Shashank R Joshi"
        placeholder="blurred"
        quality={100}
      />
    ),
  },
  {
    id: "mohsin-wali",
    drName: "Dr Mohsin Wali",
    designation: "Senior Consultant",
    company: "SIR GANGA RAM HOSPITAL, New Delhi",
    drImage: (
      <StaticImage
        src="../../../images/aboutUs/mohan@2x.png"
        alt="Moushin Wali"
        placeholder="blurred"
        quality={100}
      />
    ),
  },
  {
    id: "rajiv-kovil",
    drName: "Dr Rajiv kovil",
    designation: "MBBS General Physician, Diabetologist",
    company: "",
    drImage: (
      <StaticImage
        src="../../../images/aboutUs/rajiv_kovil@2x.png"
        alt="Rajiv kovil"
        placeholder="blurred"
        quality={100}
      />
    ),
  },
];

const MedicalAdvisoryBoardNew = ({
  title = "Medical Advisory Board",
  members = teamDetails,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [selectedMember, setSelectedMember] = useState(null);

  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const handleReadBio = member => {
    // Find full member details from memberDetails
    const fullMemberData = memberDetails.find(m => m.id === member.id);

    if (fullMemberData) {
      setSelectedMember(fullMemberData);
      setShowModal(true);
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedMember(null);
  };

  return (
    <>
      <section className={styles.medicalAdvisorySection}>
        <div
          className={`container scroll_animate ${inView && "inview"}`}
          ref={ref}
        >
          {/* Heading */}
          <div className="row">
            <div className="col-12">
              <h2 className={styles.sectionTitle}>{title}</h2>
            </div>
          </div>

          {/* Team Members Grid */}
          <div className={`row ${styles.teamGrid}`}>
            {members.map((member, index) => (
              <div key={index} className="col-6 col-md-6 col-lg-4">
                <TeamMemberCard member={member} onReadBio={handleReadBio} />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Bio Modal */}
      <BioModal
        show={showModal}
        onHide={handleCloseModal}
        member={selectedMember}
      />
    </>
  );
};

MedicalAdvisoryBoardNew.propTypes = {
  title: PropTypes.string,
  members: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      drName: PropTypes.string.isRequired,
      designation: PropTypes.string.isRequired,
      company: PropTypes.string,
      drImage: PropTypes.node.isRequired,
    })
  ),
};

export default MedicalAdvisoryBoardNew;
